"use client"

import React from "react"
import { usePathname } from "next/navigation"
import { env } from "env"

import { getSyncDictionary } from "@/lib/sync-dictionary"
import { ArticleShare } from "@/components/ui/molecules"

const ArticleShareResolver = () => {
  const pathname = usePathname()
  const url = `${env.NEXT_PUBLIC_APP_FRONTEND_URL}${pathname}`

  const handleCopyUrl = (url: string) => {
    navigator.clipboard.writeText(url)
  }

  return (
    <ArticleShare
      sharedString={getSyncDictionary().page.news.shareArticle}
      copyAction={() => handleCopyUrl(url)}
      urlShare={url}
    />
  )
}

export { ArticleShareResolver }
